import { ReactNode } from 'react';
import { TdsIcon } from '@scania/tegel-react';

export type MenuItemTitle = 'Use customer name' | 'Use chassis number' | 'Define chassis manually' | 'Sandbox mode';

export interface MenuItem {
  title: MenuItemTitle;
  description: string;
  icon: ReactNode;
  dataTestid?: string;
  disabled?: boolean;
}

const menuItems: MenuItem[] = [
  {
    title: 'Use customer name',
    description: 'Load customers chassis numbers',
    icon: <TdsIcon name="profile" size="20px" />,
    dataTestid: 'use-customer-name-menu-item',
  },
  {
    title: 'Use chassis number',
    description: 'Input chassis numbers',
    icon: <TdsIcon name="truck" size="20px" />,
    dataTestid: 'use-chassis-number-menu-item',
  },
  {
    title: 'Define chassis manually',
    description: 'Create vehicles from scratch',
    icon: <TdsIcon name="document_tool" size="20px" />,
    dataTestid: 'define-chassis-manually-menu-item',
    disabled: true,
  },
];

export default menuItems;
